import * as types from '../mutation-types'

const state = {
    auth: {},
    user: {}
}

const getters = {
    auth: state => state.auth,
    user: state => state.user
}

const actions = {
    logout ({ commit }) {
        commit(types.USER_PROFILE_LOGOUT)
    }
}

const mutations = {
    [types.USER_PROFILE_LOGIN](state, auth) {
        state.auth = auth
    },

    [types.USER_PROFILE_SET](state, user) {
        state.user = user
    },

    [types.USER_PROFILE_LOGOUT](state) {
        state.user = {}
        state.auth = {}
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}